import React from "react";
import Tab from "./Tab";

/**
 * TabList component to render all open tabs
 * @param {Object} props - Component props
 * @param {Array} props.tabs - Array of tab objects
 * @param {Object} props.activeTab - Currently active tab
 * @param {Set} props.modifiedFiles - Set of modified file paths
 * @param {Function} props.onTabClick - Tab click handler
 * @param {Function} props.onTabClose - Tab close handler
 * @returns {JSX.Element} The tab list
 */
const TabList = ({
  tabs,
  activeTab,
  modifiedFiles,
  onTabClick,
  onTabClose,
}) => {
  if (tabs.length === 0) {
    return null;
  }

  return (
    <>
      {tabs.map((tab, index) => (
        <Tab
          key={`${tab.path}-${index}`}
          tab={tab}
          isActive={activeTab && activeTab.path === tab.path}
          isModified={modifiedFiles.has(tab.path)}
          onClick={onTabClick}
          onClose={onTabClose}
          onMiddleClick={onTabClose}
        />
      ))}
    </>
  );
};

export default TabList;
